<template>
  <div class="orderList">
      <p class="noticeDevice">请前往电脑端进行报价操作</p>
      <!-- 搜索框 -->
      <div class="searchBox">
        <el-row :gutter="24">
          <el-col :span="12">
              <el-input v-model="searchTitle" placeholder="请输入项目编号或标题搜索查询" @change="searchOrder"></el-input>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="searchOrder">搜索</el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 导航条 -->
      <el-tabs v-model="activePage" @tab-click="changeOrderStatus">
        <el-tab-pane label="未开始" name="-1"></el-tab-pane>
        <el-tab-pane label="进行中" name="1"></el-tab-pane>
        <el-tab-pane label="已结束" name="0"></el-tab-pane>
      </el-tabs>
      <!-- 数据列表 -->
      <el-table
        :data="orderList"
        stripe
        style="width: 100%">
        <el-table-column
          prop="_title"
          label="标题"
          width="300"
          >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row._title" placement="top">
              <el-button @click="orderDntry(scope.row)" type="text" size="small">{{scope.row._title}}</el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="_sts"
          label="当前状态"
          width="100">
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="发布时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="start_time"
          label="报价开始时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="finsh_time"
          label="报价结束时间"
          width="160">
        </el-table-column>
        <!-- <el-table-column
          fixed="right"
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button @click="orderDntry(scope.row)" type="text" size="small">查看</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <!-- 分页效果 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        stripe="true"
        :total="total">
      </el-pagination>

  </div>
</template>
<script>
import { Order } from '../../api';
export default {
  name:'orderList',
  data(){
    return {
      activePage:'1',
      orderList:[],
      
      cate_id:'',
      sts:1,
      currentPage:0,
      pageSize:10,
      total:0,

      searchTitle:'',
    }
  },
  watch:{
    $route(to,from){ //监听路由变化，数据动态操作  
      to,from
      this.changeOrderQuery();
    },
  },
  mounted(){
    var params = this.$route.query;
    if (params) {
      this.cate_id = params.cate_id
    }
    this.getOrderList();
  },
  methods:{
    getOrderList(){ //获取默认订单列表
      var that = this;
      var postData = {
        title:this.searchTitle,
        cate_id:this.cate_id,
        sts:this.sts,
        currentPage:this.currentPage,
        pageSize:this.pageSize
      };
      //订单请求
      Order(postData).then(res=>{
        if (res.code == 200) {
          that.currentPage = res.data.currentPage;
          that.total = parseInt(res.data.total);
          that.orderList = res.data.list;
        }
      })
    },
    changeOrderStatus(){ //点击导航条效果
      this.sts = this.activePage;
      this.getOrderList();
    },
    handleCurrentChange(val){ //跳转到某页
      this.currentPage = val;
      this.getOrderList();
    },
    pageSizeChange(val){// 更换每页条数处理
      this.pageSize = val;
      this.getOrderList();
    },
    changeOrderQuery(){ //数据监听
      this.cate_id = this.$route.query.cate_id
      this.getOrderList();
    },
    orderDntry(e){ //查看订单详情
      console.log(e);
      let routerUrl = this.$router.resolve({
        path:'/orderDetail',
        query:{code:e.code}
      });
      console.log(routerUrl.href);
      window.open(routerUrl.href,'_blank')
    },
    searchOrder(){ //订单搜索
      // if (!this.searchTitle){
      //   this.$message.error("搜索选项不能为空");
      //   return false;
      // }
      this.getOrderList();
    }

  }
}
</script>

<style lang="less" scoped>
.noticeDevice{display: none;}
@media screen and(max-width:480px) {
  .noticeDevice{
    display: block;
    margin: 15px;
    text-align: center;
    font-size: 18px;
    color: red;
  }
  .searchBox{
    margin:0px;
    padding:0px;
    overflow-x: hidden!important;;
  }
  .el-row{
    padding: 0px;
    margin: 0px;
  }
}
</style>